
import Box from '@mui/material/Box'
import SavingsRoundedIcon from '@mui/icons-material/SavingsRounded'
import dayjs from 'dayjs'

import DetailHeader from '@/components/collection-point/detail/detail-header'
import CollectionPointDetailBins from '@/components/collection-point/detail/waste-containers'
import HeadingWithIcon from '@/components/heading-with-icon'
import MixedWeightDiscountTarget from './mixed-weight-discount-target'
import MixedVolumeDiscountTarget from './mixed-volume-discount-target'
import ForcedDiscountTarget from './forced-discount-target'
import type {
    CollectionCalendarEntry,
    CollectionPointBioWeightCategory,
    CollectionPointDetail,
    CollectionPointMixedVolumeCategory,
    CollectionPointMixedWeightCategory,
} from '@/types'
import BioWeightDiscountTarget from './bio-weight-discount-target'

export default function CollectionPointDetailWrapperPublic({
    singleHousehold,
    discountForSorting,
    discountForVolume,
    discountForBio,
    collectionCalendar,
} : {
    singleHousehold: CollectionPointDetail,
    discountForSorting: CollectionPointMixedWeightCategory,
    discountForVolume: CollectionPointMixedVolumeCategory,
    discountForBio: CollectionPointBioWeightCategory,
    collectionCalendar: Array<CollectionCalendarEntry>,
}) {
    
    const data = singleHousehold

    const disabledDiscounts = data.force_discount_cents === 0 || (!data.force_discount_cents && data.mixed_volume_categories_disabled && data.mixed_weight_categories_disabled && data.bio_weight_categories_disabled)
    
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
        }}>
            <Box  sx={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                <DetailHeader collectionPointDetail={data} readOnly />
            </Box>
            {!disabledDiscounts &&
                <Box>
                    <HeadingWithIcon
                        text="Slevový cíl"
                        icon={<SavingsRoundedIcon />}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                md: 'row',
                            },
                            flexWrap: 'wrap',
                            columnGap: 3,
                            rowGap: 2,
                            pt: 2,
                        }}
                    >
                        {data.force_discount_cents ? 
                            <ForcedDiscountTarget amountCents={data.force_discount_cents} />
                            :
                            <>
                                {!data.mixed_weight_categories_disabled &&
                                    <MixedWeightDiscountTarget
                                        collectionPointId={data.id}
                                        year={Number.parseInt(dayjs().format('YYYY'))}
                                        publicLinkData={discountForSorting}
                                    />
                                }
                                {!data.mixed_volume_categories_disabled &&
                                    <MixedVolumeDiscountTarget
                                        collectionPointId={data.id}
                                        year={Number.parseInt(dayjs().format('YYYY'))}
                                        publicLinkData={discountForVolume}
                                        publicLinkCalendarData={collectionCalendar}
                                    />
                                }
                                {!data.bio_weight_categories_disabled &&
                                    <BioWeightDiscountTarget
                                        collectionPointId={data.id}
                                        year={Number.parseInt(dayjs().format('YYYY'))}
                                        publicLinkData={discountForBio}
                                    />
                                }
                            </>
                        }
                    </Box>
                </Box>
            }
            <CollectionPointDetailBins bins={data.bins} readOnly />
        </Box>
    )
}
